import React from 'react';
import { Modal } from 'antd';
const CustomModal = ({
    modalTitle="",
    modalContent=() => null,
    open=false,
    handleConfirm=()=>{},
    handleCancel=()=>{},
    children,
    hideFooter=false,
    ...props
}) => {
  
  const handleOk = () => {
    handleConfirm();
  };
  const handleCancelClick = () => {
    handleCancel();
  };
  return (
    <>
      <Modal
        open={open}
        maskClosable={false}
        title={modalTitle}
        onOk={handleOk}
        onCancel={handleCancelClick}
        
        footer={!hideFooter ? (_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        ) : null}
        {...props}
      >
        {children}
      </Modal>
    </>
  );
};
export default CustomModal;